module.exports = __webpack_public_path__ + "img/coupons1.64b4364b.jpg";